var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74219 9.67969L11.5391 11.4766C11.6172 11.5547 11.6172 11.7109 11.5391 11.7891L7.08594 16.2422L5.21094 16.4375C4.9375 16.4766 4.74219 16.2812 4.78125 16.0078L4.97656 14.1328L9.42969 9.67969C9.50781 9.60156 9.66406 9.60156 9.74219 9.67969ZM12.9844 9.25C13.2969 9.5625 13.2969 10.0312 12.9844 10.3438L12.2031 11.125C12.125 11.2031 12.0078 11.2031 11.9297 11.125L10.0938 9.28906C10.0156 9.21094 10.0156 9.09375 10.0938 9.01562L10.875 8.23438C11.1875 7.92188 11.6562 7.92188 11.9688 8.23438L12.9844 9.25ZM17.75 4.875V18.625C17.75 19.6797 16.8906 20.5 15.875 20.5H2.125C1.07031 20.5 0.25 19.6797 0.25 18.625V4.875C0.25 3.85938 1.07031 3 2.125 3H4V0.96875C4 0.734375 4.19531 0.5 4.46875 0.5H6.03125C6.26562 0.5 6.5 0.734375 6.5 0.96875V3H11.5V0.96875C11.5 0.734375 11.6953 0.5 11.9688 0.5H13.5312C13.7656 0.5 14 0.734375 14 0.96875V3H15.875C16.8906 3 17.75 3.85938 17.75 4.875ZM15.875 18.3906V6.75H2.125V18.3906C2.125 18.5469 2.20312 18.625 2.35938 18.625H15.6406C15.7578 18.625 15.875 18.5469 15.875 18.3906Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.690bfb7e9c8346a98bfd9027a642ae1b.svg";
export { ForwardRef as ReactComponent };